// ? [REVISIT] manually review this file
//@ts-nocheck

import React, { useState, Fragment, useEffect, useRef } from 'react';
import { Form, Label, Input, Row, Col } from 'reactstrap';
import SuccessBlock from './SuccessBlock';
import { handleFormEvents, pushEventToGTMDataLayer } from 'src/scripts/utils/gtm-data-layer';

const CScontactForm = () => {
  const [reason, setReason] = useState(null);
  const [subject] = useState('Alo Contact Form');
  const [didYouKnowDisplay, setDidYouKnowDisplay] = useState(false);
  const [didYouKnowText, setDidYouKnowText] = useState(null);
  const [orderStatusText] = useState(null);
  const [isSuccessPage, setIsSuccessPage] = useState(false);

  const inRegardsToSelect = useRef(null);

  const updateSubject = (_e) => {
    let subjectValue = `${document.getElementById('00N1J00000F41Yb').value} / ${
      document.getElementById('00N1J00000F5P1Y').value
    }`;
    setDidYouKnowSituation(subjectValue);
    const orderNo = document.getElementById('00N1J00000F4IAW').value;
    if (orderNo !== '') {
      subjectValue = subjectValue + ` (#${orderNo})`;
    }
  };

  const setDidYouKnowSituation = (typeOfRequest) => {
    var loggedInStatus = window.serverSideVariables.customerEmail && window.serverSideVariables.customerEmail !== '';
    var isPro = window.serverSideVariables.isPro;
    var proMessage = '';
    if (!loggedInStatus) {
      proMessage = 'You are NOT currently logged in. ';
    } else if (!isPro) {
      proMessage = `You are logged into the account ${window.serverSideVariables.customerEmail}, which does not have an active Pro membership.`;
    } else if (isPro) {
      proMessage = 'You are currently logged into a Pro Membership on this device.';
    }
    var reasonsToCannedMessages = {
      'Pro Program / Problem Using Discount': (
        <Fragment>
          {proMessage} Your Pro Discount can only be applied when you have logged in, by going to{' '}
          <a href="/account">My Account</a>, <strong>before</strong> going to Checkout. If your Pro membership is
          active, you will see a message at the top of the <a href="/account">My Account</a> page with the Pro discount
          code.
        </Fragment>
      ),
      'Order Status/Changes / Order Status': (
        <Fragment>
          {orderStatusText} Orders typically take 1-3 business days to ship. You will receive an email confirmation and
          tracking number once your order has shipped. If you have an aloyoga.com account, you can log in and view order
          status and tracking on the My Dashboard page, under recent orders. Or, check your order status by simply
          clicking <a href="/pages/track-my-order">here</a>. You can opt into text order updates on the confirmation
          page.
        </Fragment>
      ),
      'Returns / Gift Returns': (
        <Fragment>
          {orderStatusText} Gifted items purchased online may be returned for store credit. The item must be unworn,
          unwashed, and unused with the original tags attached. If you are the gift recipient reaching out, please
          ensure you enter your email address in the above email field.
        </Fragment>
      ),
    };
    if (reasonsToCannedMessages[typeOfRequest]) {
      setDidYouKnowText(reasonsToCannedMessages[typeOfRequest]);
      setDidYouKnowDisplay(true);
    } else {
      setDidYouKnowDisplay(false);
    }
  };

  const updateReason = (event) => {
    setReason(event.target.value);
    inRegardsToSelect.current.options[0].selected = true; // Reset "in regards to" select on reason change
    updateSubject();
  };

  useEffect(() => {
    const isSuccess = window.location.search.includes('success=true');
    setIsSuccessPage(isSuccess);
    if (isSuccess) {
      pushEventToGTMDataLayer({ event: 'contact_form_submit', form: 'contact' });
    }
    return () => {};
  }, []);

  const contactFormStartEvent = () => handleFormEvents('contact_form_start');

  return isSuccessPage ? (
    <SuccessBlock />
  ) : (
    <div className="formWrapper">
      <div className="form-header">
        <h1 style={{ marginBottom: 6 }} className="h1 uppercase center">
          Email us
        </h1>
        <p style={{ marginBottom: 30 }} className="large-p center">
          We’re here to help! Please fill out the information below.
        </p>
        <p style={{ marginBottom: 26 }} className="pre-headline uppercase">
          <span style={{ color: '#FF0707' }}>*</span>required fields
        </p>
      </div>
      <Form
        className="cs-form"
        action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
        method="POST"
      >
        <input type="hidden" name="orgid" value="00Do0000000JcB2" />
        <input type="hidden" name="retURL" value="https://aloyoga.com/pages/email-us?success=true" />
        <input type="hidden" name="recordType" id="recordType" value="0121J000001DcSOQA0" />
        <input type="hidden" id="subject" name="subject" value={subject} />

        <Label className="pre-headline uppercase" htmlFor="name">
          <span style={{ color: '#FF0707' }}>*</span>Name
        </Label>
        <Input
          className="small-p"
          id="name"
          maxLength="80"
          name="name"
          size="20"
          type="text"
          required={true}
          autoComplete="name"
          onChange={contactFormStartEvent}
        />

        <Label className="pre-headline uppercase" htmlFor="email">
          <span style={{ color: '#FF0707' }}>*</span>Email (Please use address used to place order if relevant)
        </Label>
        <Input
          className="small-p"
          id="email"
          maxLength="80"
          name="email"
          size="20"
          type="email"
          required={true}
          autoComplete="email"
          onChange={contactFormStartEvent}
        />
        <Row>
          <Col xs="12" md="6">
            <Label htmlFor="00N1J00000F41Yb" className="pre-headline uppercase">
              {' '}
              <span style={{ color: '#FF0707' }}>*</span>What can we help with?:{' '}
            </Label>
            <Input
              className="small-p"
              type="select"
              id="00N1J00000F41Yb"
              name="00N1J00000F41Yb"
              title="Inquiry Reason"
              onChange={(e) => {
                updateReason(e);
                contactFormStartEvent();
              }}
              required={true}
            >
              <option value="" hidden>
                Select one
              </option>
              <option value="Alo Moves">Alo Moves</option>
              <option value="Order Status/Changes">Order Status/Changes</option>
              <option value="Returns">Returns</option>
              <option value="Pro Program">Pro Program</option>
              <option value="Friend Referral Program">Friend Referral Program</option>
              <option value="Product Inquiries">Product Inquiries</option>
              <option value="Stores/Studios">Stores/Studios</option>
              <option value="Wholesale">Wholesale</option>
              <option value="Other">Other</option>
            </Input>
          </Col>
          <Col xs="12" md="6">
            <Label
              htmlFor="00N1J00000F5P1Y"
              style={reason && reason !== '' ? null : { opacity: 0.5 }}
              className="pre-headline uppercase"
            >
              <span style={{ color: '#FF0707' }}>*</span>In regards to?:{' '}
            </Label>
            <select
              ref={inRegardsToSelect}
              className="small-p form-control"
              id="00N1J00000F5P1Y"
              name="00N1J00000F5P1Y"
              title="Alo Sub Inquiry Reason"
              onChange={(e) => {
                contactFormStartEvent();
                updateSubject(e);
              }}
              disabled={reason && reason !== '' ? false : true}
              required={true}
            >
              <InRegardsTo reason={reason} />
            </select>
          </Col>
        </Row>
        <div id="DidYouKnowSection" style={{ display: didYouKnowDisplay ? 'block' : 'none' }}>
          <h4 className="h4">ℹ️ Did you know?</h4>
          <p className="small-p">{didYouKnowText}</p>
        </div>
        <Row>
          <Col xs="12" md="6">
            <Label htmlFor="00N1J00000F4IAW" className="pre-headline uppercase">
              Order # (Example:1160410):{' '}
            </Label>
            <Input
              className="small-p"
              id="00N1J00000F4IAW"
              maxLength="8"
              onChange={(e) => {
                contactFormStartEvent();
                updateSubject(e);
              }}
              name="00N1J00000F4IAW"
              size="20"
              type="text"
            />
          </Col>
        </Row>
        <Label className="pre-headline uppercase" htmlFor="description">
          <span style={{ color: '#FF0707' }}>*</span>Message
        </Label>
        <Input
          className="small-p"
          type="textarea"
          required={true}
          style={{ height: 150 }}
          name="description"
          onChange={contactFormStartEvent}
        />
        <input
          style={{ maxWidth: 170, marginTop: 45, fontWeight: 900 }}
          className="main-button text-uppercase mx-auto"
          type="submit"
          name="submit"
        />
      </Form>
    </div>
  );
};

const InRegardsTo = ({ reason }) => {
  return reason === 'Alo Moves' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="30 Day free trial">30 Day free trial</option>
      <option value="Annual Subscription">Annual Subscription</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Order Status/Changes' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Order Status">Order Status</option>
      <option value="Make a Change">Make a Change</option>
      <option value="Gift Card">Gift Card</option>
      <option value="Cancel">Cancel</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Returns' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Make a Return">Make a Return</option>
      <option value="Return Status">Return Status</option>
      <option value="Apparel Defect">Apparel Defect</option>
      <option value="Gift Returns">Gift Returns</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Pro Program' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Application">Application</option>
      <option value="Problem Using Discount">Problem Using Discount</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Friend Referral Program' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Code Not Working">Code Not Working</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Product Inquiries' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Fit">Fit</option>
      <option value="Styling">Styling</option>
      <option value="Back in Stock">Back in Stock</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Stores/Studios' ? (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
      <option value="Product Availability">Product Availability</option>
      <option value="Information">Information</option>
      <option value="Other">Other</option>
    </Fragment>
  ) : reason === 'Wholesale' ? (
    <option value="Other">Other</option>
  ) : reason === 'Other' ? (
    <option value="Other">Other</option>
  ) : (
    <Fragment>
      <option value="" hidden>
        Select one
      </option>
    </Fragment>
  );
};

export default CScontactForm;
